const SolutionStatus = {
  LINKED: "linked",
  NOT_LINKED: "notLinked",
  OUT_OF_SCOPE: "outOfScope",
  INCOMPATIBLE: "incompatible",
  INCOMPATIBLE_OUT_OF_SCOPE: "incompatibleOutOfScope"
} as const;

type SolutionStatusType = typeof SolutionStatus[keyof typeof SolutionStatus];

const ALL = Object.values(SolutionStatus);

const isEffectivelyOutOfScope = (status: SolutionStatusType): boolean =>
  (
    [
      SolutionStatus.OUT_OF_SCOPE,
      SolutionStatus.INCOMPATIBLE,
      SolutionStatus.INCOMPATIBLE_OUT_OF_SCOPE
    ] as SolutionStatusType[]
  ).includes(status);

export default { ...SolutionStatus, ALL, isEffectivelyOutOfScope };
